import React from 'react'
//import './style/About.css'
import './style/Footer.css'

function Footer() {
  return (
    <div className="footer">
      <div className="footerSocial">
            <a target="_blank" href="https://www.linkedin.com/in/anouar-salhi-984499216/"><i class="fab fa-linkedin-in"></i></a>
            <a target="_blank" href="https://github.com/AnouarSalhi"><i class="fab fa-github"></i></a>
            <a href="#"><i class="fab fa-twitter"></i></a>
          
            
          </div>
     <div className='footerText'>Designed and built with <i class="fas fa-heart love"></i> by <a href="https://www.linkedin.com/in/anouar-salhi-984499216/">Anouar Salhi</a>.</div> 
     <p className='footerText'>&copy; 2022 </p>
    </div>
  );
}

export default Footer;
